import { get, get2, post, post2 } from './api';

export const userControl = {
	// 登录
	login: (data) => post('?c=d_school&m=login', data),
	// 获取验证码
	yzm: (data) => get('?c=d_school&m=rand_create_code', data),
	// 修改密码
	updatePwd: (data) => post('?c=d_school&m=updatePwd', data),
	// 获取logo
	getlogo: (data) => post('?c=d_school&m=schoolName', data),
	// 首页数据
	sysj: (data) => post('?c=d_admin&m=admindata', data),
	// 菜单
	cdlist: (data) => post('?c=d_admin&m=authlist', data),
	// 上传
	upload:(data) => post('?c=d_school&m=uploadFile', data),

}
export const login = (data) => post('?c=d_school&m=login', data)

// 账号列表
export const userlist = {
	userlist: (data) => post('?c=d_school&m=userList', data),
	// 学院列表
	xylist: (data) => post('?c=d_admin&m=collegelist', data),
	// 成员列表
	cylist: (data) => post('?c=d_admin&m=adminList', data),
	// 基地分类
	sfzxfl: (data) => post('?c=d_admin&m=exampleCate', data),
	// 创建示范中心基地
	sfzxadd: (data) => post('?c=d_admin&m=addexample', data),
	// 示范中心列表
	sfzxlist: (data) => post('?c=d_admin&m=exampleList', data),
	// 示范中心详情
	sfzxinfo: (data) => post('?c=d_admin&m=exampleinfo', data),
	// 示范中心编辑
	sfzxupdata: (data) => post('?c=d_admin&m=editexample', data),
	//示范中心删除
	sfzxremove: (data) => post('?c=d_admin&m=delexample', data),
	//基地成果添加
	sfzxhdadd: (data) => post('?c=d_admin&m=addexamplenews', data),
	//基地成果列表
	sfzxhdlist: (data) => post('?c=d_admin&m=exampleNewList', data),
	//基地成果详情
	sfzxhdinfo: (data) => post('?c=d_admin&m=exampleNewInfo', data),
	// 基地成果编辑
	sfzxhdupdata: (data) => post('?c=d_admin&m=editexamplenews', data),
	// 基地成果删除
	sfzxhdremove: (data) => post('?c=d_admin&m=delexamplenews', data),
	// 基地活动列表
	sfzxcglist: (data) => post('?c=d_admin&m=exampleAnList', data),
	// 基地活动添加
	sfzxcgadd: (data) => post('?c=d_admin&m=addexampleal', data),
	// 基地活动详情
	sfzxcginfo: (data) => post('?c=d_admin&m=exampleAnInfo', data),
	// 基地活动删除
	sfzxcgremove: (data) => post('?c=d_admin&m=delexampleAn', data),
	// 基地活动编辑
	sfzxcgbj: (data) => post('?c=d_admin&m=editexampleAn', data),
	// 政策列表
	sfzxzclist: (data) => post('?c=d_admin&m=policyList', data),
	// 政策添加
	sfzxzcadd: (data) => post('?c=d_admin&m=addpolicy', data),
	// 政策详情
	sfzxzcinfo: (data) => post('?c=d_admin&m=policyInfo', data),
	// 政策删除
	sfzxzcremove: (data) => post('?c=d_admin&m=delpolicy', data),
	// 中心审核
	sfzxsh: (data) => post('?c=d_admin&m=examplePass', data),
	// 中心审核列表
	sfzxshlist: (data) => post('?c=d_admin&m=example_examlist', data),
	// 政策编辑
	sfzxzcupdata: (data) => post('?c=d_admin&m=editpolicy', data),
	// 教师信息
	userinfo: (data) => post('?c=d_school&m=userInfo', data),
	// 修改教师信息
	userupdata: (data) => post('?c=d_school&m=renewinfo', data),
	// 修改学院信息
	xyupdata: (data) => post('?c=d_school&m=editCollegeNumber', data),
	//添加教师账号
	useradd: (data) => post('?c=d_school&m=addUser', data),
	//添加学院账号
	userxyadd: (data) => post('?c=d_school&m=addCollegeNumber', data)
}
// 实践基地
export const shsj = {
	// 基地列表
	sjjd: (data) => post('?c=d_adsz&m=baseList', data),
	// 基地添加
	sjjdadd: (data) => post('?c=d_adsz&m=addbase', data),
	// 基地详情
	sjjdinfo: (data) => post('?c=d_adsz&m=baseInfo', data),
	// 基地编辑
	sjjdup: (data) => post('?c=d_adsz&m=editbase', data),
	// 基地删除
	sjjdremove: (data) => post('?c=d_adsz&m=delbase', data),
	// 学习资源
	xxzylist: (data) => post('?c=d_adsz&m=baseStudyRes', data),
	// 添加学习资源
	xxzyadd:(data) => post('?c=d_adsz&m=addBaseStudy', data),
	//学习资源详情
	xxzyinfo:(data) => post('?c=d_adsz&m=studyResInfo', data),
	//学习资源编辑
	xxzyup:(data) => post('?c=d_adsz&m=editStudyRes', data),
	//学习资源删除
	xxzyremove:(data) => post('?c=d_adsz&m=delStudyRes', data),
	// 实践项目列表
	sjxmlist: (data) => post('?c=d_adsz&m=practiceList', data),
	// 项目添加
	sjxmadd: (data) => post('?c=d_adsz&m=addpractice', data),
	// 项目编辑
	sjxup: (data) => post('?c=d_adsz&m=editpractice', data),
	// 项目详情
	sjxminfo: (data) => post('?c=d_adsz&m=practiceInfo', data),
	// 基地分类
	jdfl: (data) => post('?c=d_adsz&m=baseAllList', data), 
	// 项目删除
	sjxmdel: (data) => post('?c=d_adsz&m=delpractice', data),
	// 实践活动列表
	sjhdlist: (data) => post('?c=d_adsz&m=activityList', data),
	// 实践活动添加
	sjhdadd: (data) => post('?c=d_adsz&m=addactivity', data),
	// 实践活动详情
	sjhdinfo: (data) => post('?c=d_adsz&m=activityInfo', data),
	// 实践活动编辑
	sjhdup: (data) => post('?c=d_adsz&m=editactivity', data),
	// 实践活动删除
	sjhddel: (data) => post('?c=d_adsz&m=delactivity', data),
	// 审核列表
	shlist: (data) => post('?c=d_adsz&m=baseExamineList', data),
	// 审核提交
	shtj: (data) => post('?c=d_adsz&m=addBaseExamine', data),
	//查看报告
	produceReport: (data) => get2('?c=dz_index&m=produceReport', data),
	// 新增报告
	ReportAdd: (data) => post2('?c=dz_index&m=produceReport', data),
	// 成员列表
	hdcylist: (data) => post('?c=d_admin&m=joinActUserList', data),
	// 成员详情
	hdcyinfo: (data) => post('?c=d_admin&m=userGwInfo', data),
	// 感悟列表
	gwlist: (data) => post('?c=d_admin&m=userGwList', data),
	// 删除感悟
	gwdel:(data) => post('?c=d_home&m=delUserGw', data),
	// 删除成员
	hdcydel:(data) => post('?c=d_admin&m=delJoinActUser', data),
	// 展示
	gshows:(data) => post('?c=d_home&m=setGwShow', data),
	// 感悟审核
	gwsh:(data) => post('?c=d_admin&m=gwExamine', data),
	// 城市列表
	cslist:(data) => post('?c=d_adsz&m=cityList', data),
}
// 新闻发布
export const news = {
	// 新闻列表
	newslist: (data) => post('?c=d_school&m=newList', data),
	// 新增新闻时模块选择列表
	newsClass: () => post('?c=d_school&m=newCate'),
	// 发布新闻
	pubNews: (data) => post('?c=d_school&m=addNews', data),
	// // 撤回新闻
	// revokeNews:(data) => post('?c=d_school&m=revokeNew',data),
	// 删除新闻
	delNews: (data) => post('?c=d_school&m=delNew', data),
	//新闻详情
	selectNew: (data) => post('?c=d_school&m=selectNew', data),
	// 编辑新闻 
	updateNews: (data) => post('?c=d_school&m=updateNew', data),
	// 筛选模块列表
	newSecondClass: () => post('?c=d_school&m=newSecondClass'),
	// 学级分类
	dzxclass: () => post('?c=d_school&m=school_level_cate'),
	// 学科门类
	xkmlclass: (data) => post('?c=d_collect&m=xkCate', data),
	// 成果分类
	cgfl: () => post('?c=d_school&m=cgCate'),
	// 共建共享
	gjgxlist: (data) => post('?c=d_school&m=resouceList', data),
	// 学校列表
	school: () => post('?c=d_collect&m=school_list'),
	// 新增共建共享
	gjgxadds: (data) => post('?c=d_school&m=addResouce', data),
	// 删除共建共享
	gjgxremove: (data) => post('?c=d_school&m=addResouce', data),
	// 共建共享编辑
	gjgxetid: (data) => post('?c=d_school&m=updateResouce', data),
	// 共建共享详情
	gjgxinfo: (data) => post('?c=d_school&m=selectResouce', data),
	// 大中小思政审核列表
	dzxsh: (data) => post('?c=d_school&m=examineNewList', data),
	// 大中小思政审核
	dzxshs: (data) => post('?c=d_school&m=submitExamineNew', data),
	// 讲师列表
	teacher: (data) => post('?c=d_admin&m=schoolTeacherList', data),
}
// 教学比赛
export const game = {
	// 比赛列表
	gamelist: (data) => post('?c=d_admin&m=gameList', data),
	// 比赛分类
	gameclass: () => post('?c=d_admin&m=gameCate'),
	// 新增比赛
	gameadd: (data) => post('?c=d_admin&m=addGame', data),
	// 比赛详情
	gameinfo: (data) => post('?c=d_admin&m=gameInfo', data),
	// 删除比赛
	removegame: (data) => post('?c=d_admin&m=delGame', data),
	// 加入比赛
	gameadds: () => post('?c=d_admin&m=userJoinGame'),
	// 筛选列表
	gameasx: (data) => post('?c=d_admin&m=jsList', data),
	// 成员列表
	gcylist: (data) => post('?c=d_admin&m=gameUserList', data),
	// 作品列表
	gamezplist: (data) => post('?c=d_admin&m=gameFileList', data),
	// 专家列表
	gamezjlist: (data) => post('?c=d_admin&m=expertList', data),
	// 新增专家
	gamezjadd: (data) => post('?c=d_admin&m=addExpert', data),
	// 专家详情
	gamezjinfo: (data) => post('?c=d_admin&m=expertInfo', data),
	// 删除专家
	gamezjremove: (data) => post('?c=d_admin&m=delExpert', data),

}
// 大先生培育
export const dxs = {
	// 大先生列表
	daxlist: (data) => post('?c=d_admin&m=excellentTeacherList', data),
	// 大先生添加
	daxadd: (data) => post('?c=d_admin&m=addExcellentTeacher', data),
	// 大先生详情
	daxinfo: (data) => post('?c=d_admin&m=excellentTeacherInfo', data),
	// 大先生分类
	dxsfl: (data) => post('?c=d_admin&m=schoolTeacherList', data),
	// 大先生删除
	dxsremove: (data) => post('?c=d_admin&m=delExcellentTeacher', data),
}
// 社会育人
export const shpy = {
	// 社会育人列表
	shpylist: (data) => post('?c=d_admin&m=socialList', data),
	// 社会育人添加
	shpyadd: (data) => post('?c=d_admin&m=addsocial', data),
	// 社会育人详情
	shpyinfo: (data) => post('?c=d_admin&m=socialInfo', data),
	//社会育人删除
	shpymove: (data) => post('?c=d_admin&m=delSocial', data),
}
// 评价系统
export const pjxt = {
	// 成果评价列表
	cgpjlist: (data) => post('?c=d_admin&m=resouceEvaluate', data),
	//工作室评价列表
	gzspj: (data) => post('?c=d_admin&m=studioEvaluate', data),
}
// 发布账号管理
export const pubadminControl = {
	// 重置密码	
	resetPwd: (data) => post('?c=d_school&m=resetPwd', data),
	// 删除账号
	delUser: (data) => post('?c=d_school&m=delUser', data),
	// 新增账号
	addUser: (data) => post('?c=d_school&m=addUser', data),
	// 批量新增
	addMore: (data) => post('?c=d_school&m=excelPutStand', data),
}

// 资源上传
export const resource = {
	// 资源列表
	resourceList: (data) => post('?c=d_school&m=resouceList', data),
	// 新增资源时模块选择列表
	moduleClass: () => post('?c=d_school&m=moduleClass'),
	// 资源审核列表
	resourceslist: (data) => post('?c=d_school&m=examineList', data),
	// 新增资源
	addResouce: (data) => post('?c=d_school&m=addResouce', data),
	// 编辑资源
	updateResource: (data) => post('?c=d_school&m=updateResouce', data),
	// 查看资源内容
	selectResouce: (data) => post('?c=d_school&m=selectResouce', data),
	// 撤回资源
	revokeResouce: (data) => post('?c=d_school&m=revokeResouce', data),
	// 删除资源
	delResouce: (data) => post('?c=d_school&m=delResouce', data),
	// 备课列表
	bklists: (data) => post('?c=d_school&m=bkreslist', data),
	// 删除规划已经上传的资源
	delUpload: (data) => post('?c=d_school&m=delUpload', data),
	// 资源下载
	zydown: (data) => get('?c=d_admin&m=down_file', data),
	// 类型列表
	moduleClassSub: (data) => post('?c=d_school&m=moduleClassSub', data),
	// 教师列表
	teacher: (data) => post('?c=d_school&m=famousTeacher', data),
}

// 内容审核
export const shenhe = {
	// 审核列表
	examineList: (data) => post('?c=d_school&m=examineList', data),
	// 通过审核
	examineResouce: (data) => post('?c=d_school&m=examineResouce', data),
}
// 学校宣传
export const schoolx = {
	// 学校宣传列表
	schoolxclist: (data) => post('?c=d_admin&m=schoolExampleList', data),
	// 添加学校宣传
	schoolxcadd: (data) => post('?c=d_admin&m=addschoolnews', data),
	//编辑学校宣传
	schoolxcup: (data) => post('?c=d_admin&m=editschoolnews', data),
	//学校宣传详情
	schoolxcinfo: (data) => post('?c=d_admin&m=schoolnewsdetail', data),
	//学校宣传删除
	schoolxcdel: (data) => post('?c=d_admin&m=delschoolnews', data),
	// 学院列表
	xylist: (data) => post('?c=d_nmres&m=collegelist', data),

}
// 培训通知
export const szpxs = {
	// 培训通知列表
	szpxslist: (data) => post('?c=d_admin&m=schooltrainlist', data),
	// 添加培训通知
	szpxsadd: (data) => post('?c=d_admin&m=addschooltrain', data),
	//编辑培训通知
	szpxsup: (data) => post('?c=d_admin&m=editschooltrain', data),
	//培训通知详情
	szpxsinfo: (data) => post('?c=d_admin&m=schooltraininfo', data),
	// 培训删除
	szpxdel: (data) => post('?c=d_admin&m=delschooltrain', data),
	// 培训课程列表
	pxkclist: (data) => post('?c=d_admin&m=trainkclist', data),
	// 培训课程添加
	pxkcadd: (data) => post('?c=d_admin&m=addtrinkc', data),
	// 培训课程编辑
	pxkcup: (data) => post('?c=d_admin&m=edittrainkc', data),
	// 培训课程详情
	pxkcinfo: (data) => post('?c=d_admin&m=trainkcinfo', data),
	// 培训课程删除
	pxkcdel: (data) => post('?c=d_admin&m=deltrainkc', data)

}
//活动管理
export const hdgl = {
	// 活动管理列表
	hdglslist: (data) => post('?c=d_admin&m=schoolactivitylist', data),
	// 活动添加
	hdgladd: (data) => post('?c=d_admin&m=addschoolactivity', data),
	// 编辑活动
	hdglup: (data) => post('?c=d_admin&m=editactivity', data),
	//活动详情
	hdglinfo: (data) => post('?c=d_admin&m=schoolactivityinfo', data),
	// 删除活动
	hdglremove: (data) => post('?c=d_admin&m=delactivity', data),
}
// 教案管理
export const jagl = {
	// 管理列表
	jagllist: (data) => post('?c=d_admin&m=teachinglist', data),
	// 讲师列表
	jslist: (data) => post('?c=d_admin&m=teacherlist', data),
	// 教案添加
	jagladd: (data) => post('?c=d_admin&m=addschoolteachplan', data),
	// 编辑教案
	jaglup: (data) => post('?c=d_admin&m=editteaching', data),
	//教案详情
	jaglinfo: (data) => post('?c=d_admin&m=schoolteachinginfo', data),
	// 章节列表
	zjlist: (data) => post('?c=d_admin&m=teachingzhanglist', data),
	// 章节添加
	zjadd: (data) => post('?c=d_admin&m=addzhangres', data),
	// 章节编辑
	zjup: (data) => post('?c=d_admin&m=editzhang', data),
	// 章节详情
	zjinfo: (data) => post('?c=d_admin&m=getzinfo', data),
	// 教案预览
	zjyl: (data) => post('?c=d_admin&m=teachingzhangInfo', data),
	// 教案关联列表
	zjgl: (data) => post('?c=d_admin&m=teachingrelationlist', data),
	// 添加关联
	addgl: (data) => post('?c=d_admin&m=addrelationres', data),
	// 章节删除
	zjremove: (data) => post('?c=d_admin&m=delteachingzhang', data),
	// 删除教案
	jaglremove: (data) => post('?c=d_admin&m=delschoolteaching', data),
	// 教案共建
	jagjlist: (data) => post('?c=d_admin&m=teachinggroup', data),
}
export const studios = {
	// 删除上传
	updates: (data) => post('?c=d_school&m=delUpload', data),
	// 分类
	modulelist: (data) => post('?c=d_admin&m=modulelist', data),
	// 搜索
	search: (data) => post('?c=d_admin&m=searchwork', data),
	// 添加工作室
	studiosadd: (data) => post('?c=d_admin&m=addwork', data),
	// 已创建工作室列表
	cjlist: (data) => post('?c=d_admin&m=studioList', data),
	// 工作室审核列表
	gzsslist: (data) => post('?c=d_admin&m=examinelist', data),
	// 工作室成员列表
	gzscylist: (data) => post('?c=d_admin&m=getstudioulist', data),
	//任务成果列表
	studiocglist: (data) => post('?c=d_admin&m=studiotasklist', data),
	//添加任务成果
	studiocgadd: (data) => post('?c=d_admin&m=addstudiotask', data),
	// 任务成果详情
	studiotaskinfo: (data) => post('?c=d_admin&m=studiotaskinfo', data),
	// 编辑任务成果
	studiotaskup: (data) => post('?c=d_admin&m=editstudiotask', data),
	// 任务成果删除
	studiotaskdel: (data) => post('?c=d_admin&m=delstudiotask', data),
	// 工作室详情
	studioinfo: (data) => post('?c=d_admin&m=workinfodetail', data),
	// 编辑工作室
	studioupdate: (data) => post('?c=d_admin&m=updatework', data),
	// 已加入工作室成员列表
	cylist: (data) => post('?c=d_admin&m=studio_ulist', data),
	// 添加负责人/成员
	studiocy: (data) => post('?c=d_admin&m=addstudiouser', data),
	// 负责人/成员详情
	studiocyinfo: (data) => post('?c=d_admin&m=studiouserinfo', data),
	// 负责人/成员编辑
	studiocyupdata: (data) => post('?c=d_admin&m=editstudiouser', data),
	// 编辑任务
	taskupdate: (data) => post('?c=d_admin&m=updatetask', data),
	// 工作室成员列表
	cylists: (data) => post('?c=d_admin&m=studiomember', data),
	// 完成作业
	resouce: (data) => post('?c=d_admin&m=submit_resouce', data),
	// 成员提交内容
	resouceinfo: (data) => post('?c=d_admin&m=resouceinfo', data),
	// 创建者评价
	addreview: (data) => post('?c=d_admin&m=addreview', data),
	// 审核
	examineResouce: (data) => post('?c=d_admin&m=exam_studio', data),
	// 删除工作室
	gzsdel: (data) => post('?c=d_admin&m=del_studio', data),

}
// 自建专题
export const special = {
	// 自建专题列表
	specialist: (data) => post('?c=d_admin&m=speciallist', data),
	// 添加专题
	specialadd: (data) => post('?c=d_admin&m=addspecial', data),
	// 专题详情
	specialinfo: (data) => post('?c=d_admin&m=specialinfo', data),
	// 编辑专题
	specialupdate: (data) => post('?c=d_admin&m=editspecial', data),
	// 删除专题
	delspecial: (data) => post('?c=d_admin&m=delspecial', data),
	// 统计
	tjlist: (data) => post('?c=d_resouce&m=statis_left&_=1573569556365', data),
	// 统计头部
	tjtop: (data) => post('?c=d_resouce&m=statis_top&_=1573569556365', data),
	// 统计右侧
	tjright: (data) => post('?c=d_resouce&m=statis_phb&_=1573569556365', data),
	// 删除文件
	updates: (data) => post('?c=d_school&m=delUpload', data),
	// 展示
	specialzs: (data) => post('?c=d_admin&m=setshow', data),
	// 师德师风
	sdsflist: (data) => post('?c=d_admin&m=teacherStyleList', data),
	// 师德师风详情
	sdsfinfo: (data) => post('?c=d_admin&m=teacherStyleInfo', data),
	// 师德师风编辑
	sdsfbj: (data) => post('?c=d_admin&m=editTeacherStyle', data),
	// 师德师风删除
	sdsfremove: (data) => post('?c=d_admin&m=delTeacherStyle', data),
	// 师德师风上传
	sdsfzdd: (data) => post('?c=d_admin&m=addTeacherStyle', data),
	// 专题资源列表
	zylist: (data) => post('?c=d_admin&m=specialreslist', data),
	// 专题资源编辑
	zyedit: (data) => post('?c=d_admin&m=editspecialres', data),
	// 专题资源上传
	zyadd: (data) => post('?c=d_admin&m=addspecialres', data),
	// 专题资源详情
	zyinfo: (data) => post('?c=d_admin&m=specialresinfo', data),
	// 专题资源删除
	zyremove: (data) => post('?c=d_admin&m=delspecialres', data),
}

export const yjyd = {
	// 引经用典列表
	yjydList: (data) => post('?c=d_school&m=information', data),
	//新增引经用典
	addYjyd: (data) => post('?c=d_school&m=addInfo', data),
	//编辑引经用典
	updateYjyd: (data) => post('?c=d_school&m=updateInfo', data),
	// 引经用典模块列表
	classList: (data) => post('?c=d_school&m=infoClass', data),
	// 编辑引经用典
	selectYjdy: (data) => post('?c=d_school&m=selectInfo', data),
	// 删除引经用典
	delYjyd: (data) => post('?c=d_school&m=delInfo', data),
	// 撤回引经用典
	revokeInfo: (data) => post('?c=d_school&m=revokeInfo', data),
	// 审核引经用典
	examineInfo: (data) => post('?c=d_school&m=examineInfo', data),
}
// 大数据观测
export const bigData = {
	// 学校列表
	schoolList: (data) => post('?c=dz_index&m=citySchoolList', data),
	//成果案例文章列表
	getAchieveList: (data) => post('?c=dz_index&m=schoolAchieveList', data),
	//成果案例文章详情
	ArticalDetail: (data) => post('?c=d_admin&m=exampleNewInfo', data),
	// 大数据数据
	dsjsj:(data) => post('?c=d_home&m=bigData', data),
	// 大数据列表
	zqlist:(data) => post('?c=d_admin&m=achieveList', data),
	// 大数据列表添加
	zqadd:(data) => post('?c=d_admin&m=addAchieve', data),
	// 大数据列表详情
	zqinfo:(data) => post('?c=d_admin&m=achieveInfo', data),
	// 大数据列表编辑
	zqbj:(data) => post('?c=d_admin&m=editAchieve', data),
	// 大数据列表删除
	zqremove:(data) => post('?c=d_admin&m=delAchieve', data),
	// 大数据分类
	zqfl:(data) => post('?c=d_admin&m=achieveDszType', data),
	// 大数据分类
	zqfls:(data) => post('?c=d_admin&m=achieveKcszType', data),
	// 审核
	zqsh:(data) => post('?c=d_admin&m=addAchieveExamine', data),
}
// 共同体
export const gtt = {
	// 实践活动列表
	sjhdlist: (data) => post('?c=d_admin&m=commActiveList', data),
	// 实践活动添加	
	sjhdadd: (data) => post('?c=d_admin&m=addCommActive', data),
	// 实践活动详情
	sjhdinfo: (data) => post('?c=d_admin&m=commActiveInfo', data),
	// 实践活动修改
	sjhdup: (data) => post('?c=d_admin&m=editCommActive', data),
	// 实践活动删除
	sjhddel: (data) => post('?c=d_admin&m=delCommActive', data),
	// 示范金课
	sfjklist: (data) => post('?c=d_admin&m=commResList', data),
	// 示范金课添加
	sfjkadd: (data) => post('?c=d_admin&m=addCommRes', data),
	// 示范金课修改
	sfjkup: (data) => post('?c=d_admin&m=editCommRes', data),
	// 示范金课详情
	sfjkinfo: (data) => post('?c=d_admin&m=commResInfo', data),
	// 示范金课删除
	sfjkdel: (data) => post('?c=d_admin&m=delCommRes', data),
	// 活动成果列表
	hdcglist: (data) => post('?c=d_adsz&m=baseActivitycgList', data),
	// 活动成果列表
	hdcgadd: (data) => post('?c=d_adsz&m=addActivitycg', data),
	// 活动成果详情
	hdcginfo: (data) => post('?c=d_adsz&m=baseActivitycgInfo', data),
	// 活动成果编辑
	hdcgbj: (data) => post('?c=d_adsz&m=editActivitycg', data),
	// 活动成果删除
	hdcgremove: (data) => post('?c=d_adsz&m=delActivitycg', data),
	// 共同体列表
	gttlist: (data) => post('?c=d_admin&m=commList', data),
	// 共同体部门
	gttbm: (data) => post('?c=d_admin&m=departList', data),
	// 共同体添加
	gttadd: (data) => post('?c=d_admin&m=addComm', data),
	// 共同体详情
	gttinfo: (data) => post('?c=d_admin&m=commInfo', data),
	// 共同体编辑
	gttbj: (data) => post('?c=d_admin&m=editComm', data),
	// 共同体删除
	gttdel: (data) => post('?c=d_admin&m=commList', data),
	// 共同体成员
	gttcylist: (data) => post('?c=d_admin&m=commMemberList', data),
	// 共同体成员添加
	gttcyadd: (data) => post('?c=d_admin&m=addCommMember', data),
	// 共同体成员详情
	gttcyinfo: (data) => post('?c=d_admin&m=commMemberInfo', data),
	// 共同体成员编辑
	gttcyup: (data) => post('?c=d_admin&m=editCommMember', data),
	// 共同体成员删除
	gttcydel: (data) => post('?c=d_admin&m=delCommMember', data),
}
// 课程思政
export const kcsz = {
	// 示范院校列表
	schoolxclist: (data) => post('?c=d_admin&m=schoolExampleList', data),
	//示范院校添加
	addSchoolExample: (data) => post('?c=d_admin&m=addSchoolExample', data),
	//示范院校详情
	schoolExampleInfo: (data) => post('?c=d_admin&m=schoolExampleInfo', data),
    // 示范院校编辑
	editschoolExampleInfo: (data) => post('?c=d_admin&m=editSchoolExample', data),
	// 示范院校删除
	delschoolExampleInfo: (data) => post('?c=d_admin&m=delSchoolExample', data),
	// 示范名师列表
	mslist: (data) => post('?c=d_admin&m=stuTeacherList', data),
	// 示范名师添加
	msadd: (data) => post('?c=d_admin&m=addTeacher', data),
	// 示范名师详情
	msinfo: (data) => get('?c=d_admin&m=updateTeacher', data),
	// 示范名师删除
	msremove: (data) => post('?c=d_admin&m=delTeacher', data),
	// 示范校审核
	sfkshx: (data) => post('?c=d_admin&m=addSchoolExamine', data),
	// 示范中心审核
	sfzxshx: (data) => post('?c=d_admin&m=submitExamine', data),
	// 示范中心审核列表
	sfzxshlist: (data) => post('?c=d_admin&m=examine_examplelist', data),
}
//大思政课
export const dszk = {
	//科目分类
	kmtab:(data) => post('?c=d_admin&m=dszKm', data),
	//所属分类
	ssfl:(data) => post('?c=d_admin&m=workCate', data),
	// 思政资源案例及素材库
	szzylist:(data) => post('?c=d_admin&m=dszSourceList', data),
	// 思政资源案例及素材库添加
	szzyadd:(data) => post('?c=d_admin&m=addDszSource', data),
	// 思政资源案例及素材库详情
	szzyinfo:(data) => post('?c=d_admin&m=dszSourceInfo', data),
	// 思政资源案例及素材库修改
	szzyup:(data) => post('?c=d_admin&m=editDszSource', data),
	// 思政资源案例及素材库删除
	szzyremove:(data) => post('?c=d_admin&m=delDszSource', data),
	// 思政问题库列表
	szwtlist:(data) => post('?c=d_admin&m=dszQuestionList', data),
	// 思政问题库添加
	szwtadd:(data) => post('?c=d_admin&m=addDszQuestion', data),
	// 思政问题库编辑
	szwtup:(data) => post('?c=d_admin&m=editDszQuestion', data),
	// 思政问题详情
	szwtinfo:(data) => post('?c=d_admin&m=dszQuestionInfo', data),
	// 思政问题删除
	szwtremove:(data) => post('?c=d_admin&m=delDszQuestion', data),
	// 示范课列表
	szsfklist:(data) => post('?c=d_admin&m=dszSfkList', data),
	// 示范课添加
	szsfkadd:(data) => post('?c=d_admin&m=addDszSfk', data),
	// 示范课详情
	szsfkinfo:(data) => post('?c=d_admin&m=dszSfkInfo', data),
	// 示范课编辑
	szsfkup:(data) => post('?c=d_admin&m=editDszSfk', data),
	// 示范课删除
	szsfkremove:(data) => post('?c=d_admin&m=delDszSfk', data),
	// 学校列表
	schoollist:(data) => post('?c=d_admin&m=ahSchoolList', data),
	// 案例审核
	alsh:(data) => post('?c=d_admin&m=addSourceExamine', data),
	// 问题审核
	wtsh:(data) => post('?c=d_admin&m=addQuestuinExamine', data),
	// 示范课审核
	sfksh:(data) => post('?c=d_admin&m=addSourceExamine', data),
	// 思政金课审核
	szjks:(data) => post('?c=d_admin&m=addDszSfkExamine', data),
}